//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
let d=[[[0,"CornerType",1,0],[0,"CutSequence",1,0],[0,"RadiusOrDistance",1,0],[0,"ReliefPlungeDistance",1,0],[0,"ReliefPlungeOffset",1,0],[0,"ReliefPlungeType",1,0]],[],[]];
SPLM.CAM.TurnGrooveCornerControl = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.TurnGrooveCornerControl";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.TurnGrooveCornerControl.CornerTypes = Object.freeze({
    "None" : "None", "FollowPart" : "FollowPart", "Round" : "Round", "Break" : "Break", "RoundIpw" : "RoundIpw", "BreakIpw" : "BreakIpw"});

SPLM.CAM.TurnGrooveCornerControl.ReliefPlungeTypes = Object.freeze({
    "None" : "None", "Depth" : "Depth", "WallDepth" : "WallDepth", "Distance" : "Distance"});

SPLM.CAM.TurnGrooveCornerControl.CutSequenceTypes = Object.freeze({
    "CornersFirst" : "CornersFirst", "CornersFirstAndLast" : "CornersFirstAndLast", "CornerWithWall" : "CornerWithWall", "CornerAfterWall" : "CornerAfterWall", "CornersLast" : "CornersLast"});

export default SPLM;